<template>
	<div class="countdown d-flex flex-row justify-content-center" :class="{ 'd-none': !isCounterAvailable }" :key="resetKey">
		<div>
			<span class="time">{{ display(days) }}</span
			><span class="unit">d</span>
		</div>
		<div>
			<span class="time">{{ display(hours) }}</span
			><span class="unit">h</span>
		</div>
		<div>
			<span class="time">{{ display(minutes) }}</span
			><span class="unit">m</span>
		</div>
		<div>
			<span class="time">{{ display(seconds) }}</span
			><span class="unit">s</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			countdownTime: { type: String, default: '' }, // ISO string
		},
		emits: ['countdown-finished'],
		data() {
			return {
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				distance: 0,
				resetKey: 0,
				timer: null,
			}
		},
		computed: {
			isCounterAvailable() {
				return this.distance > 0
			},
		},
		watch: {
			countdownTime: {
				handler() {
					if (!this.timer) {
						this.startCountdown()
					}
				},
				immediate: true,
			},
			distance: {
				handler() {
					if (this.distance <= 0) {
						this.$emit('countdown-finished')
						clearInterval(this.timer)
					}
				},
			},
		},
		mounted() {
			this.startCountdown()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		methods: {
			display(number) {
				return String(number).padStart(2, '0')
			},
			startCountdown() {
				if (!this.countdownTime) return
				const endDate = new Date(this.countdownTime).getTime()
				if (isNaN(endDate)) return

				const update = () => {
					const now = new Date().getTime()
					const newDistance = endDate - now
					this.distance = newDistance
					this.calculation(newDistance)
				}

				update()
				this.timer = setInterval(update, 1000)
			},
			calculation(dist) {
				if (dist < 1) {
					if (this.timer) clearInterval(this.timer)
					this.resetKey++
					this.days = 0
					this.hours = 0
					this.minutes = 0
					this.seconds = 0
				} else {
					this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
					this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
					this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
					this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.countdown {
		gap: 0.2rem;
	}
</style>
